import { createFileRoute } from "@tanstack/react-router";
import { tabSearch } from "@/app/tabs";
import { PendingSurface } from "@/components/feedback/pending-surface";
import { requirePerm } from "@/lib/auth/guards";
export const Route = createFileRoute("/_authenticated/settings")({
  // Retired `?tab=` ids resolve to the tab that absorbed them — `app/tabs.ts`.
  validateSearch: tabSearch("settings"),
  beforeLoad: requirePerm("admin.staff"),
  component: () => <PendingSurface titleKey="nav.settings" />,
});
